import type { Configuration } from '@repo/api-gw-sdk';
import { IntegrationsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/integrations';

export const integrations = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const integrationsApi = new IntegrationsApi(config);

  return {
    useList: () =>
      httpClient.execute(
        integrationsApi.listIntegrations.bind(integrationsApi),
        baseUrl,
        '',
        currentProjectId
      ),
  };
};
